import {
  BooleanParam,
  NumberParam,
  StringParam,
  useQueryParams,
  withDefault,
} from 'use-query-params'
import { Button } from '@pepper/ui'

import AppliedFilterPill from 'components/idea-lab/AppliedFilterPill'

type Props = {
  formatTopicsAndKeywordsCount: (value: string) => void
}

export const SuggestionsFilter = ({ formatTopicsAndKeywordsCount }: Props) => {
  const [queryParams, setQueryParams] = useQueryParams({
    sug_keyword: withDefault(StringParam, undefined),
    sug_topic: withDefault(StringParam, undefined),
    theme_id: withDefault(StringParam, undefined),
    sug_positionLte: withDefault(NumberParam, undefined),
    sug_positionGte: withDefault(NumberParam, undefined),
    sug_exclude_position: withDefault(BooleanParam, false),
  })
  return (
    <>
      {queryParams.sug_topic && (
        <AppliedFilterPill
          label={`Topic Contains: ${formatTopicsAndKeywordsCount(
            queryParams.sug_topic
          )}`}
          onClear={() =>
            setQueryParams({
              sug_topic: undefined,
            })
          }
        />
      )}
      {queryParams.sug_keyword && (
        <AppliedFilterPill
          label={`Inc. Keywords: ${formatTopicsAndKeywordsCount(
            queryParams.sug_keyword
          )}`}
          onClear={() =>
            setQueryParams({
              sug_keyword: undefined,
            })
          }
        />
      )}
      {queryParams.sug_positionLte && queryParams.sug_positionGte && (
        <AppliedFilterPill
          label={`Pos: ${queryParams.sug_positionGte} - ${queryParams.sug_positionLte}`}
          onClear={() =>
            setQueryParams({
              sug_positionGte: undefined,
              sug_positionLte: undefined,
              sug_exclude_position: undefined,
            })
          }
        />
      )}
      {queryParams.sug_exclude_position &&
        !queryParams.sug_positionLte &&
        !queryParams.sug_positionGte && (
          <AppliedFilterPill
            label="Exclude positions"
            onClear={() =>
              setQueryParams({
                sug_exclude_position: undefined,
              })
            }
          />
        )}
      <Button
        type="link"
        onClick={() =>
          setQueryParams({
            sug_keyword: undefined,
            sug_positionLte: undefined,
            sug_positionGte: undefined,
            sug_exclude_position: undefined,
          })
        }
      >
        Clear Filter
      </Button>
    </>
  )
}
